import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  message = 'Loading...', 
  fullScreen = false 
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  };

  const spinner = (
    <>
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${sizeClasses[size]}`}></div>
      {message && <p className="mt-2 text-gray-600">{message}</p>}
    </>
  );

  if (fullScreen) {
    return (
      <div className="flex flex-col justify-center items-center min-h-screen">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center p-4">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;